import React from 'react';
import { componentMap } from './compMapping';
import { grey } from 'sushiweb/tokens/color';

export default function CopyMessageList(props) {
  const { details, setValues = () => {} } = props;

  return (
    <div
      css={`
        background: ${details?.bg_color || '#e5f3f35c'};
        padding: ${details?.padding || '1rem'};
        border-radius: ${details?.border_radius || '5px'};
        display: flex;
        flex-direction: ${details?.orientation === 'vertical'
          ? 'column'
          : 'row'};
        gap: ${details?.gap || '0.5rem'};
        width: ${details?.width || '100%'};
        border: ${details?.border || '1px solid #b5b5b578'};
      `}
    >
      {details?.children.length > 0 &&
        details?.children.map((child, index) => {
          let CompName = '';
          if (child.type in componentMap)
            CompName = componentMap[`${child.type}`];
          else return null;
          return (
            <>
              <CompName
                details={child}
                setValues={setValues}
                inputKey={child?.id}
                key={index}
              />
              {index != details?.children.length - 1 ? (
                <hr width='2' size='1' color={grey.z400} />
              ) : null}
            </>
          );
        })}
    </div>
  );
}
